import { format } from 'date-fns';
import { useDayPicker } from 'react-day-picker';

import { colors } from '@tempmee/tailwind';
import { OutlineChevronRightIcon } from '@tempmee/react-icons';

export function MonthSelection(props) {
  const { goToMonth, nextMonth, previousMonth } = useDayPicker();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 12px',
      }}
    >
      <button
        type="button"
        style={{
          all: 'unset',
          cursor: !previousMonth ? 'default' : 'pointer',
          opacity: !previousMonth ? 0 : 1,
          transform: 'rotate(180deg)',
          width: 20,
          height: 20,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        disabled={!previousMonth}
        onClick={() => previousMonth && goToMonth(previousMonth)}
        data-cy="previous-month"
      >
        <OutlineChevronRightIcon size={10} color={colors.secondary[500]} />
      </button>
      <span
        style={{
          fontFamily: 'Nunito',
          color: colors.neutral[600],
          fontSize: 22,
          fontWeight: 700,
        }}
      >
        {format(props.calendarMonth.date, 'MMMM yyy')}
      </span>
      <button
        type="button"
        style={{
          all: 'unset',
          cursor: 'pointer',
          width: 20,
          height: 20,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        disabled={!nextMonth}
        onClick={() => nextMonth && goToMonth(nextMonth)}
        data-cy="next-month"
      >
        <OutlineChevronRightIcon size={10} color={colors.secondary[500]} />
      </button>
    </div>
  );
}
